<template>
  <div id="loader" v-show="$store.getters.isSpinnerSpinning">
    <div class="loader-message">

      <!-- The visual space above the "please wait" text -->
      <div class="loader-visual">

        <!-- Some dots -->
        <div class="dot dot0"></div>
        <div class="dot dot1"></div>
        <div class="dot dot2"></div>
        <div class="dot dot3"></div>

        <!-- Two spinner div -->
        <div class="outerSpinner"></div>
        <div class="innerSpinner"></div>

        <!-- Some circles -->
        <div class="circlesWrapper">
          <div class="circle" v-for="n in 11" :class="`circle${n-1}`" :key="`circle_${n-1}`"></div>
        </div>

        <!-- PRINTER -->
        <div class="printerLoader">
          <svg version="1.1" id="printer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 720 393.8" style="enable-background:new 0 0 720 393.8;" xml:space="preserve">
          <path d="M653.6,15.7H65.7C38.8,15.7,17,37,17,63.3v260.5c0,26,21.3,47.1,47.8,47.6c0.3,5.5,5,10,10.8,10h138
          c5.8,0,10.4-4.4,10.8-9.9h270.5c0.3,5.5,5,9.9,10.8,9.9h138c5.8,0,10.4-4.4,10.8-10c26.5-0.5,47.8-21.6,47.8-47.6V63.3
          C702.3,37,680.5,15.7,653.6,15.7L653.6,15.7z M593.8,93.5c-8.7,0-15.8-6.9-15.8-15.4s7.1-15.4,15.8-15.4c8.7,0,15.8,6.9,15.8,15.4
          S602.5,93.5,593.8,93.5z M638.7,93.5c-8.7,0-15.8-6.9-15.8-15.4s7.1-15.4,15.8-15.4s15.8,6.9,15.8,15.4S647.5,93.5,638.7,93.5z"/>
        </svg>
        <div class="paperTop">
          <div class="paperTopAnimated"></div>
        </div>
        <div class="paperBottom">
          <p>{{ $t('pageLitteracy.spinner_printer_msg') }}</p>
          <div class="paperBottomAnimated"><p>{{ $t('pageLitteracy.spinner_printer_msg') }}</p>
          </div>
        </div>
      </div>




      <div class="coffeeLoader">
        <div class="smoke">
          <svg id="smoke1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 109.2 289" preserveAspectRatio="none" style="width:20%;">
            <path class="coffeeSmoke" d="M58, 0.8s8.4,15.5,8.1,41c0,0-25.8,23.9-14.9,54.9,0,0,4.2,14.2,21.6,33,0,0,24,26.2,26.4,58.5,0,0,3,28.4-17.3,55.6,0,0-14.9,19.7-30,29.1,0,0-7.8-9-9-32.6,0,0-1-8.1,4.5-13.2,0,0,10.3-10.7,12.3-23.6,0,0,3.2-13.9-2.3-26.2,0,0-10.3-22.9-23.3-34.9,0,0-22.3-26.8-24.1-56.2,0,0-.8-31.3,16.7-54.9,0,0,21.3-22.9,31.3-30.4Z"/>
          </svg>
          <svg id="smoke2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 109.2 289" preserveAspectRatio="none" style="width:20%;">
            <path class="coffeeSmoke2" d="M58,7.8s8.4,15.5,8.1,41c0,0-25.8,23.9-14.9,54.9,0,0,4.2,14.2,21.6,33,0,0,24,26.2,26.4,58.5,0,0,3,28.4-17.3,55.6,0,0-14.9,19.7-30,29.1,0,0-7.8-9-9-32.6,0,0-1-8.1,4.5-13.2,0,0,10.3-10.7,12.3-23.6,0,0,3.2-13.9-2.3-26.2,0,0-10.3-22.9-23.3-34.9,0,0-22.3-26.8-24.1-56.2,0,0-.8-31.3,16.7-54.9,0,0,21.3-22.9,31.3-30.4Z"/>
          </svg>
        </div>
        <svg id="mug" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
          <path class="mugIcon" d="M96 64c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L96 64zM480 224l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128zM32 416l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32z"/>
        </svg>
      </div>

    </div>

    <!-- "Please wait" text -->
    <div class="loaderText">{{$t('pageTitles.wait')}}</div>

  </div>
</div>
</template>

<script></script>

<style scoped lang="scss"></style>